import type { Timestamp } from '@bufbuild/protobuf/wkt'

/** 一覧の列見出しクリックで並べる向き。 */
export type SortOrder = 'asc' | 'desc'

/** a が b より前なら負、同時なら 0、後なら正。 */
export function compareTimestamp(a: Timestamp, b: Timestamp): number {
  const secA = Number(a.seconds)
  const secB = Number(b.seconds)
  if (secA !== secB) return secA - secB
  return a.nanos - b.nanos
}
